import FormField from './field';

export default class SearchableDropdown extends FormField {
    constructor(parent, el) {
        super(parent, el);
        this.api = el.dataset.api;
        this.noMatchFoundText = el.dataset.notFoundText;
        this.searchInput = el.querySelector('#SearchDropdownInput');
        this.dropdown = el.querySelector('#dropdownContent');
        this.filteredOptions = [];
        this.valueSelected = false;
        this.activeIndex = -1;
        this.init();
    }

    init() {
        fetch(this.api, { method: 'GET' })
            .then((response) => response.json())
            .then((data) => {
                this.options = data;
            });
        this.searchInput.addEventListener('input', this.handleInput.bind(this));
        this.searchInput.addEventListener('focus', this.handleFocus.bind(this));
        this.searchInput.addEventListener('keydown', this.handleKeyDown.bind(this));
        document.addEventListener('click', this.handleDocumentClick.bind(this));
        this.dropdown.addEventListener('click', this.handleOptionClick.bind(this));
    }

    handleInput() {
        const filter = this.searchInput.value.toLowerCase();
        this.filteredOptions = this.options.filter((option) => option.toLowerCase().startsWith(filter));

        if (filter === '') {
            this.toggleDropdown(false);
        } else {
            this.populateDropdown();
            this.toggleDropdown(true);
        }

        this.valueSelected = false;
        this.activeIndex = -1;
    }

    handleFocus() {
        if (this.searchInput.value !== '') {
            this.populateDropdown();
            this.toggleDropdown(true);
        }
    }

    handleDocumentClick(event) {
        if (!event.target.closest('.dropdown')) {
            if (!this.valueSelected && this.searchInput.value !== '') {
                this.searchInput.value = '';
            }
            this.toggleDropdown(false);
        }
    }

    handleOptionClick(event) {
        if (event.target.matches('div')) {
            if (event.target.textContent === this.noMatchFoundText) {
                this.searchInput.value = '';
            } else {
                this.searchInput.value = event.target.textContent;
                this.valueSelected = true;
            }
            this.toggleDropdown(false);
        }
    }

    handleKeyDown(event) {
        const options = this.dropdown.querySelectorAll('div');
        if (event.key === 'ArrowDown') {
            if (this.dropdown.classList.contains('show')) {
                this.activeIndex = (this.activeIndex + 1) % options.length;
                this.updateActiveOption(options);
                this.scrollToOption(options[this.activeIndex]); // Ensure visibility
                this.searchInput.value = options[this.activeIndex].textContent; // Set input value to selected option
            }
            event.preventDefault();
        } else if (event.key === 'ArrowUp') {
            if (this.dropdown.classList.contains('show')) {
                this.activeIndex = (this.activeIndex - 1 + options.length) % options.length;
                this.updateActiveOption(options);
                this.scrollToOption(options[this.activeIndex]); // Ensure visibility
                this.searchInput.value = options[this.activeIndex].textContent; // Set input value to selected option
            }
            event.preventDefault();
        } else if (event.key === 'Enter') {
            if (this.activeIndex >= 0 && this.activeIndex < options.length) {
                options[this.activeIndex].click();
            }
            event.preventDefault();
        } else if (event.key === 'Tab') {
            if (this.activeIndex >= 0 && this.activeIndex < options.length) {
                this.searchInput.value = options[this.activeIndex].textContent;
                this.valueSelected = true;
            } else {
                this.searchInput.value = '';
                this.valueSelected = false;
            }
            this.toggleDropdown(false);
            this.searchInput.blur(); // Remove focus from input field
        }
    }

    updateActiveOption(options) {
        options.forEach((option, index) => {
            if (index === this.activeIndex) {
                option.classList.add('active');
            } else {
                option.classList.remove('active');
            }
        });
    }

    populateDropdown() {
        this.dropdown.innerHTML = '';

        if (this.filteredOptions.length > 0) {
            this.filteredOptions.forEach((option) => {
                const div = document.createElement('div');
                div.textContent = option;
                this.dropdown.appendChild(div);
            });
        } else {
            const noMatch = document.createElement('div');
            noMatch.textContent = this.noMatchFoundText;
            this.dropdown.appendChild(noMatch);
        }
    }

    toggleDropdown(show) {
        this.dropdown.classList.toggle('show', show);
    }

    scrollToOption(option) {
        const dropdownRect = this.dropdown.getBoundingClientRect();
        const optionRect = option.getBoundingClientRect();

        if (optionRect.bottom > dropdownRect.bottom) {
            this.dropdown.scrollTop += optionRect.bottom - dropdownRect.bottom;
        } else if (optionRect.top < dropdownRect.top) {
            this.dropdown.scrollTop -= dropdownRect.top - optionRect.top;
        }
    }

    static is(el) {
        return super.is(el) && el.classList.contains('rc-search-dropdown');
    }
}
